"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.previewMessages = exports.paymentMethodLabels = exports.maxPreviewMessage = void 0;
var _reactIntl = require("react-intl");
var _constants = require("../../constants/constants");
var _defineMessages;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var paymentMethodLabels = (0, _reactIntl.defineMessages)((_defineMessages = {}, _defineProperty(_defineMessages, _constants.PAYMENT_METHOD_ALIAS.ADYEN_DROPIN, {
  id: 'paymentMethod.adyen.label',
  description: 'Label for Adyen Dropin',
  defaultMessage: 'Credit/ Debit Card'
}), _defineProperty(_defineMessages, _constants.PAYMENT_METHOD_ALIAS.CREDIT_CARD, {
  id: 'paymentMethod.creditCard.label',
  description: 'Label for Native Credit Card',
  defaultMessage: 'Credit/ Debit Card'
}), _defineProperty(_defineMessages, _constants.PAYMENT_METHOD_ALIAS.PAYPAL, {
  id: 'paymentMethod.paypal.label',
  description: 'Label for PayPal',
  defaultMessage: 'PayPal'
}), _defineProperty(_defineMessages, _constants.PAYMENT_METHOD_ALIAS.ZIP_PAY, {
  id: 'paymentMethod.zippay.label',
  description: 'Label for ZipPay',
  defaultMessage: 'Zip'
}), _defineProperty(_defineMessages, "ADYEN_DROPIN_SINGLE_PAYMENT_METHOD", {
  id: 'paymentMethod.adyen.single.label',
  description: 'Label for Adyen Dropin',
  defaultMessage: 'Credit/ Debit Card'
}), _defineProperty(_defineMessages, _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY, {
  id: 'paymentMethod.googlePay.label',
  description: 'Label for GooglePay',
  defaultMessage: 'Google Pay'
}), _defineProperty(_defineMessages, _constants.PAYMENT_METHOD_ALIAS.APPLE_PAY, {
  id: 'paymentMethod.applePay.label',
  description: 'Label for ApplePay',
  defaultMessage: 'Apple Pay'
}), _defineMessages));

// This is to be used to define the messages for preview texts
// in the accordion when the payment method is in disabled/unselected state
// To be updated when a payment method requires preview
exports.paymentMethodLabels = paymentMethodLabels;
var previewMessages = (0, _reactIntl.defineMessages)(_defineProperty({}, _constants.PAYMENT_METHOD_ALIAS.ZIP_PAY, {
  id: 'paymentMethod.zippay.preview.message',
  description: 'Preview Message for Zip',
  defaultMessage: 'To use Zip, amount must be between {minAmount} and {maxAmount}'
}));
exports.previewMessages = previewMessages;
var maxPreviewMessage = (0, _reactIntl.defineMessages)(_defineProperty({}, _constants.PAYMENT_METHOD_ALIAS.ZIP_PAY, {
  id: 'paymentMethod.zipPay.maxCartAmount',
  description: 'Preview Message for Zip',
  defaultMessage: 'The maximum order value to use Zip is {amount}'
}));
exports.maxPreviewMessage = maxPreviewMessage;